import Repository from "./Repository"

const Aresource = "askquestionsansweredlist"
const Qresource = "askquestions"

export default {
  /**
   * Get Questions
   * @param {Integer} userId
   * @param {Integer} circleId
   * @param {Integer} page
   * @param {Integer} limit
   */
  getQuestions(user, circleId, page, limit) {
    return Repository.get(`${Qresource}/?${`user_id=${user.id}`}&circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at&role=${user.role}`)
  },

  /**
   * Get Question By ID
   * @param {Integer} userId
   * @param {Integer} circleId
   * @param {Integer} page
   * @param {Integer} limit
   */
  getQuestionById(circleId, page, limit, quesId) {
    return Repository.get(`${Qresource}/?id=${quesId}&circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at`)
  },

  /**
   * Get Answers
   * @param {Integer} userId
   * @param {Integer} circleId
   * @param {Integer} page
   * @param {Integer} limit
   */
  getAnswers(user, circleId, page, limit) {
    return Repository.get(`${Aresource}/?${`user_id=${user.id}`}&circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at&role=${user.role}`)
  },

  /**
   * Get Question comments
   * @param {integer} quesId
   * @param {integer} page
   * @param {integer} limit
   */
  getQuestionComments(quesId, page, limit, id) {
    const c_id = id ? "&id=" + id : ""
    return Repository.get(`/commentsquestionlist/?page_num=${page}&items=${limit}&question_parent_id=${quesId}${c_id}`)
  },

  /**
   * Get comments
   *
   * @param {*} quesId
   * @param {*} page
   * @param {*} limit
   * @param {*} circleId
   */
  getComments(quesId, page, limit, circleId, id) {
    const c_id = id ? "&id=" + id : ""
    return Repository.get(`/questioncomments/?page_num=${page}&items=${limit}&question_id=${quesId}&circle_id=${circleId}&sort=Popular${c_id}`)
  },

  postComment(payload, circleId) {
    return Repository.post(`/comments/?circle_id=${circleId}`, payload)
  },

  /**
   * Search Questions
   * @param {integer} query
   * @param {integer} page
   * @param {integer} limit
   */
  searchQuestions(query, category, page, limit, circle_id, sort, id) {
    let c = category ? `&category=${category}` : ""
    let s = sort ? `&sort=${sort}` : ""
    let k = id ? `&id=${id}` : ""
    return Repository.get(`/questionsearch/?key=${query}&page_num=${page}&items=${limit}&circle_id=${circle_id}` + c + k + s)
  },

  /**
   * get QA question category options
   */
  getQuestionCategories() {
    return Repository.get(`/mastertable/?type=category`)
  },

  getAllQuestions(circleId, page, limit) {
    return Repository.get(`/askquestions/?circle_id=${circleId}&role=${this.authUser.user.role}&page_num=${page}&items=${limit}&sort_by=-created_at`)
  },
}



// WEBPACK FOOTER //
// ./src/repositories/qaRepository.js